import { useCallback, useState } from 'react';
import { createPortal } from 'react-dom';
import '../battleStatTooltip.css';

/** Above deploy-drag-overlay (10000001) and global [data-tooltip] pseudo-elements. */
const BATTLE_STAT_TOOLTIP_Z_INDEX = 10000002;

/**
 * Fixed-position downward stat tooltip portaled to document.body (escapes HUD transform stacks).
 */
export function useBattleStatTooltip() {
  const [tooltip, setTooltip] = useState(null);

  const showStatTooltip = useCallback((event, text) => {
    if (text == null || text === '') return;
    const rect = event.currentTarget.getBoundingClientRect();
    setTooltip({
      text: String(text),
      x: rect.left + rect.width / 2,
      y: rect.bottom + 10,
    });
  }, []);

  const hideStatTooltip = useCallback(() => {
    setTooltip(null);
  }, []);

  const statTooltipPortal =
    tooltip && typeof document !== 'undefined'
      ? createPortal(
          <div
            className="battle-stat-tooltip-portal"
            style={{
              position: 'fixed',
              left: `${tooltip.x}px`,
              top: `${tooltip.y}px`,
              zIndex: BATTLE_STAT_TOOLTIP_Z_INDEX,
            }}
            aria-hidden="true"
          >
            {tooltip.text}
          </div>,
          document.body
        )
      : null;

  return { showStatTooltip, hideStatTooltip, statTooltipPortal };
}
